import { createContext } from 'react';
const DatabaseContext = createContext({});
export const DatabaseProvider = DatabaseContext.Provider;
export const DatabaseConsumer = DatabaseContext.Consumer;

export default DatabaseContext;
